import useSanityClient from '@/clients/sanity/'
import type { CMSGwmPromotions } from '@/types/sanity'

const gwpQuery = `*[_type == "gwpPromotions"] {
  ...,
  'productTags': tags[]-> {
    label,
    theme
  },
  tiers[] {
    ...,
    giftProduct -> {
      ...,
      store {
            ...,
            "variants": variants[] {
                  _type == "reference" => @-> {
                        ...
                  }
            }
      }
    },
    giftProductVariant -> {
        ...,
        store {
              ...
        }
    }
  }
}`

export const getGiftData = async (): Promise<CMSGwmPromotions> => {
  const res = await useSanityClient.fetch(gwpQuery)

  return res
}
